import { Button } from "@/components/ui/button";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { useUpdateSession } from "@/features/session/api/update-session";
import { queryClient } from "@/lib/react-query";
import { PublicSession, SessionInvitesStatus } from "@classview/shared-types";

import { getPendingSessionsQueryKey } from "../api/get-pending-sessions";
import { getOrgSessionStatus } from "../utils/get-org-session-status";

type RejectSessionModalProps = {
  session: PublicSession;
};

export function RejectSessionModal(props: RejectSessionModalProps) {
  const { session } = props;
  const { organisation } = useOrganisation();

  const { mutateAsync: updateSession, isPending } = useUpdateSession({
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: getPendingSessionsQueryKey({
          organisationId: organisation.id,
        }),
      });
    },
  });
  const status = getOrgSessionStatus({
    orgId: organisation.id,
    session,
  });

  if (
    status === SessionInvitesStatus.REJECTED ||
    status === SessionInvitesStatus.HOST
  ) {
    return null;
  }

  if (session.recurringDetails?.id) {
    return (
      <Button variant="outline" disabled>
        Dismiss
      </Button>
    );
  }
  return (
    <Button
      variant="outline"
      disabled={isPending}
      isLoading={isPending}
      onClick={() =>
        updateSession({
          id: session.id,
          session: {
            isAcceptingInvite: false,
          },
        })
      }
    >
      Dismiss
    </Button>
  );
}
